import { render, staticRenderFns } from "./CustomMade.vue?vue&type=template&id=071cb526&"
import script from "./CustomMade.vue?vue&type=script&lang=js&"
export * from "./CustomMade.vue?vue&type=script&lang=js&"
import style0 from "./CustomMade.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports